import { render, staticRenderFns } from "./SelectorSolicitud.vue?vue&type=template&id=68358d6a"
import script from "./SelectorSolicitud.vue?vue&type=script&lang=js"
export * from "./SelectorSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports